
export const axis = (neg: boolean, pos: boolean) => (pos ? 1 : 0) + (neg ? -1 : 0);
